// extracted by mini-css-extract-plugin
export default {"heroContainer":"hero_heroContainer__EpJt9","heroImage":"hero_heroImage__fqVOU","heroTitle":"hero_heroTitle__5aIbH"};